'use client';
import React from 'react';
import { useTranslation } from 'react-i18next';

import PharmaMedizinopferDetail from '@/components/v2/pharmaopfer/PharmaMedizinopferDetail.tsx';
import DetailContainer from 'components/v2/section-detail/DetailContainer.tsx';

const PharmaMedizinopferDetailPage = ({
  params
}: {
  params: {
    id: string;
  };
}) => {
  const { id } = React.use(params);
  const [t] = useTranslation();

  const editForms = {
    de: '205a56e2-348c-4041-a5a3-d782a1d90f7e',
    en: '205a56e2-348c-4041-a5a3-d782a1d90f7e'
  };

  return (
    <DetailContainer
      mainPage="/pharma-medizinopfer"
      editForms={editForms}
      id={Number(id)}
      textEditBtn={t('common.eintrag_bearbeiten')}
    >
      <PharmaMedizinopferDetail id={Number(id)} />
    </DetailContainer>
  );
};

export default PharmaMedizinopferDetailPage;
